
import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";

import { axiosInstance } from "../../utility/apiInstance";
import { useParams } from "react-router-dom";
import TabularViewTraclist from "../../components/TabularViewTraclist";
import AirEventTimeLine from "../../components/AirTracking/AirEventTimeLine";
import AirTrackingHeading from "../../components/AirTracking/AirTrackingHeader";
import toast from "react-hot-toast";
import { FlagType } from "../../components/TabularViewofFlagList";
const defaultTheme = createTheme();

interface Milestone {
  status: number;
  milestone: string;
  origin?: string;
  station?: string;
  date: string;
}


const AwbTrackingPage = () => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const [milestones, setMilestones] = useState<Milestone[]>([]);
  const [firstMilestones, setFirstMilestones] = useState<any[]>([]);
  const [lastMilestones, setLastMilestones] = useState<any[]>([]);
  const [trackList, settrackList] = useState(null) as any;
  const { encodedawb } = useParams();
  const [dialogIndex, setdialogIndex] = useState<null | number>(null);
  const [tabularViewData, settabularViewData] = useState({
    events: [],
    first: [],
    last: []
  });
  const [flag, setFlags] = useState<FlagType[]>([]);

  useEffect(() => {
    awsTrackedList();
    async function awsTrackedList() {
      try {
        const response: any = await axiosInstance.get(
          `/api/v1/awb-tracked-list/track/${encodedawb}`
        );
        if (response.data.success) {
          settrackList(response.data.data);
          setMilestones(response.data.data.events);
          setFirstMilestones(response.data.data.first);
          setLastMilestones(response.data.data.last);
          let { status, flightsEtdEta, events, first, last } = response?.data.tabular;
          events = events?.map((item: any) => ({ ...item, status: "event" }));
          const mergerdRes = [...status, ...flightsEtdEta, ...events] as any;
          settabularViewData({ events: mergerdRes, first, last });
          setFlags(response?.data?.data?.flag || [])
        }
      } catch (error: any) {
        toast.error(error?.response?.data?.error || "")
      }
    }
  }, [encodedawb]);




  return (
    <ThemeProvider theme={defaultTheme}>
      <Box
        sx={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div className="min-h-screen">
          <div className="grid grid-cols-12 gap-x-4 p-5">
            {/* Section 3 - Top left */}

            <div className=" lg:col-span-7 col-span-12">
              <AirTrackingHeading trackList={trackList} />

              {/* Section 1 - Bottom left */}
              <div className="">
                {tabularViewData != null && (
                  <TabularViewTraclist tabularViewData={tabularViewData} flags={flag} />
                )}
              </div>
            </div>

            {/* Section 2 - Right side (spans 2 rows) */}
            <div className=" lg:col-span-5 col-span-12">
              <div className="whiteBox whiteBoxCustom trackpadding">
                <div className="old_dashboard_title text-center">
                  <h1 className="text-2xl  text-gray-700 mt-[-15px] mb-[10px]">
                    Events Timeline
                  </h1>
                </div>

                <div className="trackNewScrollAIR">
                  <AirEventTimeLine milestones={milestones} trackList={trackList} firstMilestones={firstMilestones} lastMilestones={lastMilestones} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </ThemeProvider>
  );
};

export default AwbTrackingPage;
